// v4.4 — Module réutilisable : boucle contenu ↔ commerce (non intrusif).
// src: 'journal' | 'kiosque' | 'search' | 'social' — utilisé pour l'analytics.
import { useNavigate } from "react-router-dom";
import { ChevronRight, Store } from "lucide-react";
import { trackCatalog } from "@/lib/catalogTracking";

export default function CatalogCrossPromo({ src = "kiosque", compact = false }) {
  const navigate = useNavigate();
  const go = () => {
    trackCatalog(src === "journal" ? "journal_to_catalog_click" : src === "search" ? "search_to_catalog_click" : "merchant_catalog_click", { src });
    navigate(`/kiosque/catalogues?src=${src}`);
  };
  return (
    <button
      onClick={go}
      data-testid="catalog-cross-promo"
      className={`w-full text-left rounded-2xl border border-amber-400/25 bg-gradient-to-r from-amber-500/10 via-amber-400/5 to-transparent hover:border-amber-400/50 transition-colors ${compact ? "px-4 py-3" : "px-4 py-4"}`}
    >
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-xl bg-amber-400/15 flex items-center justify-center shrink-0">
          <Store size={19} className="text-amber-300" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-[13.5px] font-bold text-amber-200">Les catalogues des commerçants AYA</div>
          <div className="text-[11.5px] text-white/55 truncate">Découvrez les produits et offres disponibles près de chez vous</div>
        </div>
        <span className="text-[12px] font-semibold text-amber-300 flex items-center shrink-0">Explorer <ChevronRight size={15} /></span>
      </div>
    </button>
  );
}
